export default "__VITE_ASSET__BcVSYKVj__"